export default __webpack_public_path__ + "static/media/main-bar-group@3x.fc58995f.png";